let _this,
sizeTimer;
import SideMenu from './components/menu/menu.vue'
import NavTop from './components/navTop/navTop.vue'
import handleIncident from './components/commonComponents/handleIncident.vue'
import teleport from './components/commonComponents/utmTeleport.vue'
import utmCallUp from './components/commonComponents/utm-call-up/utm-call-up.vue';

export default {
  name: 'App',
  components: {
    SideMenu,
    NavTop,
    handleIncident,
    teleport,
    utmCallUp
  },
  data() {
    return {
      displayDashboardBtnRoutes: [
        '/alarmMap',
        '/statisticalChart',
        '/carParkDashboard',
        '/facilityManagement',
        '/branchPortal',
        '/faceTracking',
        '/watchList',
        '/watchListTable',
        '/currentUser',
        '/overstayer',
        '/currentVehicle',
        '/overstayVehicle',
        '/occupancyMonitoring',
        '/incidentDashboard',
        '/armingDashboard'
      ],
    }
  },
  beforeMount() {
    _this = this;
  },
  mounted() {
    _this = this;
    this.$nextTick(()=>{
      this.draggableButton();
      _this.getContentSize();
    });
    window.addEventListener('resize', ()=>{
      console.log('resize')
      clearTimeout(sizeTimer);
      sizeTimer = setTimeout(()=>{
        _this.getContentSize();
        _this.$root.getTableMaxHeight();
        _this.handleResize()
      },200);
    });
  },
  filters: {
    customDisplay: function (value) {
      if( _this ){
        return _this.ApiService.getConfigFieldsText(value);
      } else {
        return value;
      }
    }
  },
  watch:{
    '$root.menu.shrink':{
      handler(){
        this.$nextTick(()=>{
          this.getContentSize();
        })
      }
    },
    '$route': {
      handler(nv){
        // 添加和移除快捷菜单拖动
        if (this.displayDashboardBtnRoutes.indexOf(nv.path) > -1) {
          this.$nextTick(()=>{
            this.draggableButton();
          });
        } else {
          $( "#dashboard_btn" ).draggable( "destroy" );
        }
      }
    },
  },
  methods: {
    getContentSize:function(){
      _this.$root.contentWidth = $('#page-content')[0].clientWidth;
      _this.$root.contentHeight = $('#page-content')[0].clientHeight;
    },
    isMobileDevice(){
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },
    // 关闭大图
    closeBigImg: function () {
      _this.$root.viewBigImage.bigImgModal = false;
      _this.$root.viewBigImage.srcStr = "";
    },
    // 跳转
    pathTo:function(path){
      _this.$router.push({path:path});
    },
    // 面包屑跳转
    navPathTo:function(level, menuObj){
      if( ( level === 2 && !_this.$root.menu.thirdTitle ) || ( level === 3 && !_this.$root.menu.forthTitle ) || !menuObj.route ){
        return;
      }
      _this.$router.push({path: menuObj.route})
    },
    //移入显示导航栏
    showStation:function (e) {
      $(e.target).find('.work-station-menu-item').addClass('show')
    },
    //移出隐藏导航栏
    hideStation:function (e) {
      $(e.target).find('.work-station-menu-item').removeClass('show')
    },
    confirmOut:function(){
      this.$root.timeOutModal = false;
      _this.$router.push('/login');
    },
    handleMouseDown: function(e){
      let dom = $( "#dashboard_btn" );
      let offset = e.clientY - dom.offset().top - 140;
      dom.draggable( "option", "cursorAt", { top: offset } );
    },
    draggableButton:function(){
      $('#dashboard_btn').draggable({
        addClasses: true,
        axis: "y",
        scroll: false,
        containment: '#content'
      });
    },
    jumpToLisence(){
      if(_this.$route.path!== '/licenceManagement'){
        _this.$router.push({path:'/licenceManagement'});
      }
    },
    handleResize() {
      // 获取窗口的宽度和高度
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      
      // 计算元素的最大可拖动范围
      const element = document.getElementById('dashboard_btn');
      if(element){
        const elementWidth = element.offsetWidth;
        const elementHeight = element.offsetHeight;
        
        const maxX = windowWidth - elementWidth;
        const maxY = windowHeight - elementHeight;
        
        // 更新元素的位置，确保不超出页面边界
        if (parseInt(element.style.left) > maxX) {
          element.style.left = maxX + 'px';
        }
        if (parseInt(element.style.top) > maxY) {
          element.style.top = maxY + 'px';
        }
      }
    },
    closeSystemNotification() {
      this.$root.changeOfficeSystemModal = false;
    },
  }
}



// WEBPACK FOOTER //
// ./src/admin/App.js